"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpandList = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _ExpandPanel = _interopRequireDefault(require("./module/ExpandPanel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const TABLE_MIN_WIDTH = 800;
const ListDiv = (0, _styles.styled)('div')({
  overflowX: 'auto',
  overflowY: 'hidden'
});
const StyledTable = (0, _styles.styled)(_material.Table)({
  minWidth: TABLE_MIN_WIDTH
});
const StyledTableHead = (0, _styles.styled)(_material.TableHead)(_ref => {
  let {
    theme
  } = _ref;
  return {
    '& th': {
      background: theme.palette.table.header.primary.main,
      color: theme.palette.table.header.primary.contrastText
    }
  };
});
const TableHeadCellTypography = (0, _styles.styled)(_material.Typography)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    color: theme.palette.table.header.primary.contrastText,
    fontWeight: 'normal',
    fontSize: theme.typography.body2.fontSize
  };
});
const TbodyDiv = (0, _styles.styled)('div')({
  width: '100%'
});
const StyledRow = (0, _styles.styled)(_material.TableRow, {
  shouldForwardProp: prop => prop !== 'even'
})(_ref3 => {
  let {
    theme,
    even
  } = _ref3;
  return {
    height: theme.spacing(4),
    background: even ? theme.palette.table.body.primary.main : theme.palette.table.body.secondary.main
  };
});
const StyledCell = (0, _styles.styled)(_material.TableCell)({
  paddingTop: 0,
  paddingBottom: 0
});

/**
 * 展開可能一覧表示部品
 * @prop {array} rowData - 一覧のデータの配列
 * @prop {boolean} [rowData.expandStatus] - 展開状態(展開する行に設定／true:開いた状態, false:閉じた状態)
 * @prop {array} rowData.rowComponents - 行に表示するコンポーネント（カラムの順）
 * @prop {number|string} rowData.depth - 階層（1から順に深くなる）
 * @prop {array} columns - カラム情報
 * @prop {string} columns.title - カラム名
 * @prop {number|string} columns.width - カラム幅(基本は固定値とし、1カラムのみautoを設定する)
 * @prop {boolean} [columns.expandColumn] - 展開操作ができるカラムのみに設定
 * @prop {string} [columns.className] - カラムに指定するclassName
 * @prop {number} [height] - 高さ（ヘッダ固定／スクロールしたい場合に指定する）
 */
class ExpandList extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "stripeIndex", 0);
    _defineProperty(this, "getNextEven", () => {
      this.stripeIndex += 1;
      return this.stripeIndex % 2 === 0;
    });
    _defineProperty(this, "createRow", (rowData, columns) => {
      this.stripeIndex = 0;
      let prevDepth = 0;
      let normal = [];
      let expands = {};
      let res = [];
      const expandColumnNum = columns.findIndex(column => column.expandColumn);
      let smrIdx = 0;
      rowData.forEach((data, index) => {
        const depth = Number(data.depth);
        if (prevDepth > 0) {
          if (depth === prevDepth) {
            // 同一
            if (data.expandStatus === undefined) {
              // 通常行
              if (depth - 1 > 0) {
                // 深さ：2以降
                if (expands[depth - 1]) {
                  expands[depth - 1].details.push(this.getDetail(data, columns, expandColumnNum, index));
                }
              } else {
                // 深さ：1
                normal.push(this.getDetail(data, columns, expandColumnNum, index));
              }
            } else {
              // 展開行
              if (depth - 1 === 0) {
                // 深さ：1
                if (normal.length > 0) {
                  const editNormal = /*#__PURE__*/_react.default.createElement(StyledTable, {
                    key: smrIdx,
                    size: "small"
                  }, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, normal));
                  res.push(editNormal);
                  normal = [];
                  smrIdx++;
                }
              }
              expands[depth] = {};
              expands[depth].details = [];
              expands[depth].summary = this.getSummary(data, columns, expandColumnNum, smrIdx);
              smrIdx++;
            }
          }
          if (depth > prevDepth) {
            // 深い
            if (data.expandStatus === undefined) {
              // 通常行
              if (expands[prevDepth]) {
                expands[prevDepth].details.push(this.getDetail(data, columns, expandColumnNum, index));
              }
            } else {
              // 展開行
              expands[depth] = {};
              expands[depth].details = [];
              expands[depth].summary = this.getSummary(data, columns, expandColumnNum, smrIdx);
              smrIdx++;
            }
            prevDepth = depth;
          }
          if (depth < prevDepth) {
            // 浅い
            for (let i = prevDepth; i >= depth; i--) {
              // 現在の深さまでの展開データを編集
              if (!expands[i]) {
                continue;
              } else {
                const detailsData = [].concat(this.editExpand(expands[i], smrIdx, index));
                smrIdx++;
                if (detailsData.length > 0) {
                  const exp = this.getExpand(expands[i].summary, detailsData);
                  if (i - 1 > 0) {
                    // 深さ：2以降
                    if (expands[i - 1]) {
                      expands[i - 1].details.push({
                        exp: exp
                      });
                    }
                  } else {
                    // 深さ：1
                    res.push(exp);
                  }
                  expands[i] = null;
                }
              }
            }
            if (data.expandStatus === undefined) {
              // 通常行
              if (depth - 1 === 0) {
                // 深さ：1
                if (normal.length > 0) {
                  const editNormal = /*#__PURE__*/_react.default.createElement(StyledTable, {
                    key: smrIdx,
                    size: "small"
                  }, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, normal));
                  res.push(editNormal);
                  normal = [];
                  smrIdx++;
                } else {
                  normal.push(this.getDetail(data, columns, expandColumnNum, index));
                }
              } else {
                expands[depth - 1].details.push(this.getDetail(data, columns, expandColumnNum, index));
              }
            } else {
              // 展開行
              expands[depth] = {};
              expands[depth].details = [];
              expands[depth].summary = this.getSummary(data, columns, expandColumnNum, smrIdx);
              smrIdx++;
            }
            prevDepth = depth;
          }
        } else {
          // 初回
          if (data.expandStatus === undefined) {
            normal.push(this.getDetail(data, columns, expandColumnNum, index));
          } else {
            expands[depth] = {};
            expands[depth].details = [];
            expands[depth].summary = this.getSummary(data, columns, expandColumnNum, smrIdx);
            smrIdx++;
          }
          prevDepth = depth;
        }
      });
      for (let i = prevDepth; i > 0; i--) {
        if (!expands[i]) {
          continue;
        } else {
          // 残りの展開データを編集
          const detailsData = [].concat(this.editExpand(expands[i], smrIdx, rowData.length + 1));
          smrIdx++;
          if (detailsData.length > 0) {
            const exp = this.getExpand(expands[i].summary, detailsData);
            if (i - 1 > 0) {
              // 深さ：2以降
              if (expands[i - 1]) {
                expands[i - 1].details.push({
                  exp: exp
                });
              }
            } else {
              // 深さ：1
              res.push(exp);
            }
          }
        }
      }
      if (normal.length > 0) {
        const editNormal = /*#__PURE__*/_react.default.createElement(StyledTable, {
          key: smrIdx,
          size: "small"
        }, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, normal));
        res.push(editNormal);
        normal = [];
        smrIdx++;
      }
      return res;
    });
    _defineProperty(this, "getExpand", (summary, details) => {
      return /*#__PURE__*/_react.default.createElement(_ExpandPanel.default, {
        key: summary.index,
        summary: summary,
        details: details,
        even: summary.even
      });
    });
    _defineProperty(this, "getDetail", (data, columns, expandColumnNum, index) => {
      const detail = /*#__PURE__*/_react.default.createElement(StyledRow, {
        key: index,
        even: this.getNextEven()
      }, data.rowComponents.map((rowComponent, idx) => {
        if (idx === expandColumnNum) {
          return /*#__PURE__*/_react.default.createElement(StyledCell, {
            key: idx,
            width: columns[idx].width,
            style: {
              paddingLeft: 32 * Number(data.depth)
            }
          }, rowComponent);
        } else {
          return /*#__PURE__*/_react.default.createElement(StyledCell, {
            key: idx,
            width: columns[idx].width
          }, rowComponent);
        }
      }));
      return detail;
    });
    _defineProperty(this, "getSummary", (data, columns, expandColumnNum, index) => {
      data = _objectSpread(_objectSpread({}, data), {}, {
        depth: Number(data.depth),
        columns: columns,
        expandColumn: expandColumnNum,
        index: index,
        even: this.getNextEven()
      });
      return data;
    });
    _defineProperty(this, "editExpand", (expandData, smrIdx, index) => {
      if (expandData.details && expandData.details.length > 0) {
        let tmpDetails = [];
        const detailsData = [];
        expandData.details.forEach(detail => {
          if (detail.exp) {
            // 展開行
            if (tmpDetails.length > 0) {
              // 通常行テーブル化
              detailsData.push(/*#__PURE__*/_react.default.createElement(StyledTable, {
                key: index,
                size: "small"
              }, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, tmpDetails)));
              tmpDetails = [];
            }
            // 展開行そのまま追加
            detailsData.push(detail.exp);
          } else {
            // 通常行一時データに追加
            tmpDetails.push(detail);
          }
        });
        if (tmpDetails.length > 0) {
          // 通常行テーブル化
          detailsData.push(/*#__PURE__*/_react.default.createElement(StyledTable, {
            key: smrIdx,
            size: "small"
          }, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, tmpDetails)));
          tmpDetails = [];
        }
        return detailsData;
      }
    });
  }
  render() {
    const {
      columns,
      rowData,
      height
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(ListDiv, null, /*#__PURE__*/_react.default.createElement(StyledTable, {
      style: height && {
        width: '99%'
      },
      size: "small"
    }, /*#__PURE__*/_react.default.createElement(StyledTableHead, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, columns.map((column, index) => {
      return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
        key: index,
        width: column.width
      }, /*#__PURE__*/_react.default.createElement(TableHeadCellTypography, null, column.title));
    })))), /*#__PURE__*/_react.default.createElement(TbodyDiv, {
      style: height && {
        height: height,
        overflowY: 'scroll'
      }
    }, this.createRow(rowData, columns)));
  }
}
exports.ExpandList = ExpandList;
ExpandList.propTypes = {
  rowData: _propTypes.default.arrayOf(_propTypes.default.shape({
    expandStatus: _propTypes.default.bool,
    rowComponents: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
    depth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })).isRequired,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    expandColumn: _propTypes.default.bool,
    className: _propTypes.default.string
  })).isRequired,
  height: _propTypes.default.number
};
var _default = exports.default = ExpandList;